import React from "react";
import "../../css/sharedStyles.css";
import "./comicDetail.css";
import axios from "axios";
import { BrowserRouter, Route, browserHistory, Switch, Link, Router,withRouter} from "react-router-dom";
import { Redirect } from 'react-router';

import {grabCharactersNew} from "../includes/grabCharactersNew.js";
import {buildRelatedCharacterQuery} from "../includes/buildRelatedCharacterQuery.js";

import {getMainCharacterData} from "../includes/axios/getMainCharacterData.js";
import LoaderAnimation from "../loaderAnimation/loaderAnimation.js";

var ComicDetailCharacters = class ComicDetailCharacters extends React.Component{
    constructor(props,newProps) {
        super(props);
        this.self = this;
        var changeCharacter = this.props.changeCharacter;
        var showComicArea = this.props.showComicArea;
        this.state = {
            redirect: false,
            showRelatedCharacters: false
          }
        
    }


    componentDidMount(){
        setTimeout(()=>{
            //var character = this.refs.characterImage2.width;
            //alert(character);
            //this.refs.characterImage2.style.height = "30px";
        },3000);
        

    }

    componentDidUpdate(prevProps){
        // var characterArray = this.props.mainComicInfo.characters;
        // var finishTest = characterArray.length -1;
        // //done is hardcoded into the array after its created in the API Axios call in grabComicsNew.js
        // if(characterArray[finishTest] === "DONE"){
    
        //     //this is a reducer() that affects the 'comicsAreaReadyToShow' property
        //     //its made false everytime updateCharacterPage.js is fired. 
        //     //then made true here when we know all data has been found in 'characterArray'
        //     //this.props.showComicArea(true);
    
        //     characterArray[finishTest] = "Break this loop"
        //     //this.props.mainComicInfo.characters.splice(-1,1);
        //  }//end if()
         
    }


    componentWillMount(){
        //set this to false each time the component starts
        this.setState({showRelatedCharacters:false});

        var comicID = this.props.mainComicInfo.comicID;
        var characterQuery = buildRelatedCharacterQuery(comicID);
        var characterData;
        var changeCharactersInComic = this.props.changeCharactersInComic;

        axios.get(characterQuery)
        .then(function (response1) {
            characterData = grabCharactersNew(response1);
            console.log(characterData);
            changeCharactersInComic(characterData);
            this.setState({showRelatedCharacters:true}) 
        }.bind(this))

    }//end componentDidMount() 


    selectCharacter(selectedCharacter,changeCharacter,showComicArea,currentCharacter){
        //this if() only does an api call if its a new character. Otherwise we just route to 
        //the character page. This was a bug in sectionFeaturedComic.js where it was doing a similar check
        //the showComicArea() was never being called so it would just load forever
        if(selectedCharacter != currentCharacter){
            getMainCharacterData(selectedCharacter,changeCharacter,showComicArea);
        }

        //routing handled where function is called bc the 'this' situation just wasnt happening
    }


    render() {
      const routeBase = localStorage.getItem("routeBase"); 
     
      var currentCharacter = this.props.characterInfo.character;

      const inlineStyle = {
        marginBottom:"10px",
        marginTop:"0",
        width:'100%',
        paddingTop:'10px',
        paddingBottom:'10px'
      }

      //declare these two functions in this scope, so they can be called correctly in getMainCharacterData() below
      //when you click on a character icon
      var changeCharacter = this.props.changeCharacter;
      var showComicArea = this.props.showComicArea;
      var selectCharacter = this.selectCharacter;
      
      //some comics actually have no related characters. If thats the case, render a 'cant find' message
      
if(this.state.showRelatedCharacters === true){      
      if(this.props.mainComicInfo.characters.length === 0){
          return(
                <div className="content_box_square characterAreaFade" style={inlineStyle}>
                    <h1 className="characterName">Characters in this Issue </h1>
                    <div className="comicCharactersArea"> 
                        I was unable to locate any related characters for this issue
                    </div>
                </div>  
          )
      }
      else{
        return (
            <div>
                <div className="content_box_square characterAreaFade" style={inlineStyle}>
                    <h1 className="characterName">Characters in this Issue </h1>
                    <div className="comicCharactersArea">
                            {
                                this.props.mainComicInfo.characters.map(function(character,index){                               
                                    return <div key={index} className="characterWrapper">
                                            <img src={ character[2] } className = "characterPic"
                                                key={index} id={character[3]} 
                                                ref={"characterImage"+index}
                                                onClick = {()=>{
                                                    selectCharacter(character[0],changeCharacter,showComicArea,currentCharacter)
                                                    this.setState({ redirect: true });
                                                    this.props.history.push(routeBase + "/character");
                                                }}
                                                alt = {"characterImage"+index}
                                            />
                                            <div className="imageName characterText">{character[0]}</div>
                                        </div>   
                                },this)
                            
                            }
                            
                    </div>
                </div>
            </div>
        );//end return
        }//end else
}//end main if() looking for showCharacters   
else{
    return(
    <div className="content_box_square" style={inlineStyle}>
        <h1 className="characterName">Characters in this Issue </h1>
        <div className="comicCharactersArea">
            <LoaderAnimation text = "Loading Characters" />
        </div>
    </div>
    )
}



}//end render
}//end class

  export default withRouter(ComicDetailCharacters);


// WEBPACK FOOTER //
// ./src/components/comicDetail/ComicDetailCharacters.js